import { put, select, takeLatest } from 'redux-saga/effects';
import { getCardViewConfig } from '../../../modules/myPrivileges/selectors/myPrivilegesSelector';
import {
  CARD_VIEW_CONTENT_LOADED,
  DETAILS_VIEW_CONTENT_LOADED,
  fetchMyPrivilegesAuthTokenSuccess,
  fetchMyPrivilegesAuthTokenFailure,
  CARD_VIEW_MOUNTED,
  DETAILS_VIEW_MOUNTED,
} from '../actions/myPrivilegesAction';
import { fetchMyPrivilegesAuthToken } from '../../../modules/myPrivileges/actions/myPrivilegesAction';

function* cardViewMounted(): any {
  const config = yield select(getCardViewConfig, 'emma-ps-fertility-solution');
  yield put({ type: CARD_VIEW_CONTENT_LOADED, config });
}

function* detailsViewMounted(action: any): any {
  const config = yield select(getCardViewConfig, 'emma-ps-fertility-solution');
  yield put({
    type: DETAILS_VIEW_CONTENT_LOADED,
    config,
    isLocked: action.payload.isLocked,
  });
}

function* fetchMyPrivilegesAuthTokenConfig(action: any): any {
  const { MyPrivilegesAuthToken } = action.config;
  const { isLocked } = action;
  if (MyPrivilegesAuthToken && MyPrivilegesAuthToken.url && !isLocked) {
    yield put(
      fetchMyPrivilegesAuthToken(
        MyPrivilegesAuthToken.url,
        fetchMyPrivilegesAuthTokenSuccess,
        fetchMyPrivilegesAuthTokenFailure,
      ),
    );
  }
}

function* MyPrivilegesSaga(): any {
  yield takeLatest(CARD_VIEW_MOUNTED, cardViewMounted);
  yield takeLatest(DETAILS_VIEW_MOUNTED, detailsViewMounted);
  yield takeLatest(
    DETAILS_VIEW_CONTENT_LOADED,
    fetchMyPrivilegesAuthTokenConfig,
  );
}

export default MyPrivilegesSaga;
